import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import {observer} from "mobx-react"
import BienStore from "../BienStore"
import axios from "axios"
@observer
class Elementsdebases extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      typesdebiens: [],
      loaded: false
    };
  }
  componentDidMount(){
    axios.get("/api/v1/typedebiens",{}).then((data)=>{

      this.setState({typesdebiens: data.data,loaded: true})
    })
  }
  render () {

    return (
      <React.Fragment>
      <h2 className="center">Données de bases</h2>
      <div className="container">
        <div className="row">
          <div className="input-field col s8">
            <input type="text" id="addr" value={BienStore.elements["adresse"]} onChange={(e) => BienStore.elements["adresse"] = e.target.value}/>
            <label htmlFor="addr">Adresse</label>
          </div>
          <div className="input-field col s2">
            <input type="text" id="num" value={BienStore.elements["numero"]} onChange={(e) => BienStore.elements["numero"] = e.target.value}/>
            <label htmlFor="num">N°</label>
          </div>
          <div className="input-field col s2">
            <input type="text" id="boite" value={BienStore.elements["boite"]} onChange={(e) => BienStore.elements["boite"] = e.target.value}/>
            <label htmlFor="boite">Boite</label>
          </div>
        </div>
        <div className="row">
          <div className="input-field col s4">
            <input type="text" id="cp"  value={BienStore.elements["cp"]} onChange={(e) => BienStore.elements["cp"] = e.target.value}/>
            <label htmlFor="cp">Code postale</label>
          </div>
          <div className="input-field col s4">
            <input type="text" id="ville"  value={BienStore.elements["ville"]} onChange={(e) => BienStore.elements["ville"] = e.target.value}/>
            <label htmlFor="ville">Ville</label>
          </div>
          <div className="input-field col s4">
            <select className="browser-default" type="text" id="pays"  value={BienStore.elements["pays"]} onChange={(e) => BienStore.elements["pays"] = e.target.value}>
              <option value="Belgique">Belgique</option>
              <option value="France">France</option>
            </select>

          </div>
        </div>
          <div className="row">
          <p>Type de bien</p>
          <div className="input-field col s6">
            <select className="browser-default" id="type"  value={BienStore.elements["typedebien"]} onChange={(e) => BienStore.elements["typedebien"] = e.target.value}>
              <option value="" disabled>Type de bien</option>
              {this.state.typesdebiens.map((bien)=>(
                  <option key={bien.id} value={bien.titre}>{bien.titre}</option>
                ))}
            </select>
          </div>
          <div className="input-field col s6">
          <select className="browser-default" id="etages"  value={BienStore.elements["etages"]} onChange={(e) => BienStore.elements["etages"] = parseInt(e.target.value)}>
              <option value="" disabled>Nombre d'étages</option>
              {[1,2,3,4,5,6,7,8,9,10].map((etage)=>(
                  <option key={etage} value={etage}>{etage}</option>
                ))}
            </select>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col s4 offset-s8">
        { BienStore.checkBaseElements ? (
          <p><Link className="btn btn-large wave" to="/Donneesdubien">Suivant</Link></p>
          ) : (
          <p><Link className="btn btn-large wave disabled" to="/" >Suivant</Link></p>

          )}
        </div>
      </div>
      </React.Fragment>
    );
  }
}

export default Elementsdebases
